import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as troubleShootDataActions from '../actions/troubleshoot.action';
import {LoadTroubleShootData} from '../actions/troubleshoot.action';
import {first, map, mergeMap} from 'rxjs/operators';
import {Store} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {WebsiteService} from "../../websites/website.service";

@Injectable()
export class TroubleShootEffect {

  loadTroubleShootData = createEffect(() => this._actions$.pipe(
    ofType(troubleShootDataActions.LOAD_TROUBLE_SHOOT_DATA),
    mergeMap((action: LoadTroubleShootData) => {
      return this._websiteService.getTroubleshootingData(action.payload.websiteId)
        .pipe(
          first(response => !!response),
          map((response: any) => {
            /*TODO change status part*/
            const _dataBooster = response.success && response.data && response.data.boosterResponse && response.data.boosterResponse.data && !response.data.boosterResponse.data.data.status ? response.data.boosterResponse.data : null;
            const _dataIO = response.success && response.data && response.data.ioResponse && response.data.ioResponse.data && !response.data.ioResponse.data.data.status ? response.data.ioResponse.data : null;
            if (_dataBooster || _dataIO) {
              return new troubleShootDataActions.LoadTroubleShootDataSuccess({
                websiteId: action.payload.websiteId,
                data: _dataBooster || _dataIO
              });
            }
            return new troubleShootDataActions.LoadTroubleShootDataFail({
              websiteId: action.payload.websiteId,
              data: 'error'
            });
          })
        );
    })
  ));

  constructor(
    private _store: Store<DbStoreState>,
    private _actions$: Actions,
    private _websiteService: WebsiteService,
  ) {
  }
}
